import i18next from "./i18n";
import type { MivoTranslationType, MivoTranslationValue } from "./ITranslation";
import { DEFAULT_MIVO_LOCALE } from "./ITranslation";
import { resolveTranslationLanguage } from "./localeNormalization";

export { resolveTranslationLanguage, tryParseLocaleParam } from "./localeNormalization";

export function getTranslation<T extends MivoTranslationType>(text: T): MivoTranslationValue<T> {
  const language = resolveTranslationLanguage(i18next.language);
  return (text[language] ?? text[DEFAULT_MIVO_LOCALE]) as MivoTranslationValue<T>;
}

/** Interim resolver for partially migrated objects: locale → en → pt-BR. */
export function pickLocalizedText<T extends MivoTranslationType>(
  text: T,
  language?: string | null,
): string {
  const key = resolveTranslationLanguage(language ?? i18next.language);
  return text[key] ?? text.en ?? text[DEFAULT_MIVO_LOCALE];
}
